import {
  missingRepresentativeTypeIds,
  representativeTypesRefusalOf,
} from '../../../components/Actors/utils/missing-representative-types.util';
import type {
  QuotationParty,
  TypeActor,
} from '../../../components/Actors/utils/missing-representative-types.util';
import type { OrganizationMemberships } from '../../../components/Actors/utils/representative-inheritances.util';

// The representative types the workflow requires of the quotation party of the list, for its
// actor form.
export interface RepresentativeTypeRequirement {
  readonly party: QuotationParty;
  readonly enabledStatusId: string;
  readonly labelOf: (typeId: string) => string;
}

// Why the representatives of the organization quotation party of the list do not carry the
// required types (their own types, else the ones of their membership): the French refusal, or
// null.
export const requiredRepresentativeTypesRefusalOf = (
  organization: Readonly<Partial<TypeActor>>,
  memberships: OrganizationMemberships['allMemberships'],
  { party, enabledStatusId, labelOf }: Readonly<RepresentativeTypeRequirement>,
): string | null =>
  organization.thirdPartyId
    ? representativeTypesRefusalOf(
        party,
        missingRepresentativeTypeIds({
          actors: [
            {
              thirdPartyId: organization.thirdPartyId,
              categoryIds: organization.categoryIds ?? [],
              representatives: organization.representatives ?? [],
            },
          ],
          organizations: [
            { _id: organization.thirdPartyId, allMemberships: memberships },
          ],
          enabledStatusId,
          party,
        }),
        labelOf,
      )
    : null;
